(() => {
  const initialized = new WeakSet();
  function init() {
    document.querySelectorAll('[data-xnote-footer]').forEach(footer => {
      if (initialized.has(footer)) return;
      initialized.add(footer);
      const media = window.matchMedia('(min-width: 701px)');
      const sync = () => footer.querySelectorAll('.xf-menu').forEach(menu => {
        menu.open = media.matches;
        const summary = menu.querySelector('summary');
        if (media.matches) summary.setAttribute('tabindex', '-1');
        else summary.removeAttribute('tabindex');
      });
      sync();
      media.addEventListener('change', sync);
      footer.querySelectorAll('.xf-menu a').forEach(link => {
        const url = new URL(link.href, location.href);
        if (url.origin === location.origin && url.pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, '')) link.setAttribute('aria-current', 'page');
      });
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(footer)) media.removeEventListener('change', sync);
      }, { once: true });
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
